<mat-card style="width: 400px; background-color: white;padding: 40px!important;margin: auto;padding-top: 100px;">
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="form-group">

            <mat-form-field class="example-full-width">
                <mat-label>Username</mat-label>
                <input type="text" formControlName="username" matInput
                    [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />

            </mat-form-field>

            <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                <div *ngIf="f.username.errors.required">Username is required</div>
            </div>
        </div>
        <div class="form-group">

            <mat-form-field class="example-full-width">
                <mat-label>Password</mat-label>
                <input matInput placeholder="Insert your password" [type]="hide ? 'text' : 'password'"
                    formControlName="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </mat-form-field>

            <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                <div *ngIf="f.password.errors.required">Password is required</div>
            </div>
        </div>
        <div class="form-group">
            <button [disabled]="loading" color='primary' style="width: 100%;" mat-raised-button>

                Login</button>
                <br>
            <br>
            <div style="text-align: center;">OU Connectez en tanq que</div>
    


        </div>
    </form>
    <button *ngIf="username" [disabled]="loading" color='default' style="width: 100%;" (click)="connectLocal()" mat-raised-button>
        {{username}}


    </button>

</mat-card>